<script>
  let portal;
  $: portal && document.body.appendChild(portal);
 
</script>

<div id="portal" bind:this={portal}>
  <slot />
</div>
